import React from 'react';
import { Card } from '@dev-go4ellis/go4-design-system';
import './WhatFeeCovers.scss';

const FEE_ITEMS = [
  'Licensure verification',
  'Professional liability insurance',
  'Stripe payment processing',
  '1099 distribution',
  'Injury documentation & record storage',
  'Emergency Action Plan generator',
];

const Check = () => (
  <span className="pl-fee__check">
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
  </span>
);

const WhatFeeCovers = () => (
  <Card padding="lg" flat className="pl-fee">
    <h3 className="pl-fee__title">What the 17.5% covers</h3>
    <p className="pl-fee__lead">Everything below is included in the fee. There are no add-on modules to buy.</p>
    <ul className="pl-fee__list">
      {FEE_ITEMS.map((label) => (
        <li key={label} className="pl-fee__item">
          <Check />
          {label}
        </li>
      ))}
    </ul>
    <div className="pl-fee__cards">
      <Card padding="md" flat className="pl-fee__sub">
        <div className="pl-fee__card-title">EAP Generator</div>
        <div className="pl-fee__card-body">Create venue-specific Emergency Action Plans in minutes. Required for compliance at most schools and facilities.</div>
      </Card>
      <Card padding="md" flat className="pl-fee__sub">
        <div className="pl-fee__card-title">EMR Documentation</div>
        <div className="pl-fee__card-body">HIPAA-compliant electronic medical records for injury tracking, treatment logs, and athlete health histories.</div>
      </Card>
    </div>
  </Card>
);

export default WhatFeeCovers;
